// Masking for personal data on screens shown in demos (the DEMO console account).
// Display-only: the values are still in the payload, this just keeps them off the screen.

const DOT = "•";

/** "rafaela.pinto@gmail.com" -> "ra•••••@gmail.com" (domain kept: it is not identifying). */
export function maskEmail(email: string | null | undefined): string | null {
  if (!email) return email ?? null;
  const at = email.indexOf("@");
  if (at < 0) return maskText(email);
  const local = email.slice(0, at);
  return `${local.slice(0, 2)}${DOT.repeat(5)}${email.slice(at)}`;
}

/** "4d62395d-ae79-46f0-91fd-b97addfd5caf" -> "4d62••••caf". */
export function maskUid(uid: string | null | undefined): string | null {
  if (!uid) return uid ?? null;
  return uid.length <= 8 ? DOT.repeat(uid.length) : `${uid.slice(0, 4)}${DOT.repeat(4)}${uid.slice(-3)}`;
}

/** "Beatriz Rodrigues Cavalcanti" -> "Beatriz C." (first name + last initial). */
export function maskName(name: string | null | undefined): string | null {
  if (!name) return name ?? null;
  const parts = name.trim().split(/\s+/);
  if (parts.length < 2) return parts[0];
  return `${parts[0]} ${parts[parts.length - 1][0]}.`;
}

/** A payments row with its identity masked; ``uid`` stays intact (keys and API calls). */
export function maskPerson<T extends { display_name: string | null; email: string | null; uid: string }>(
  u: T,
): T {
  return {
    ...u,
    display_name: maskName(u.display_name),
    email: u.email ? maskEmail(u.email) : maskUid(u.uid),
  };
}

function maskText(s: string): string {
  return `${s.slice(0, 2)}${DOT.repeat(Math.max(3, s.length - 2))}`;
}
